import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import MainImageHeader from "./styledComponents/mainImageHeader.component";
import MainWordContainer from "./styledComponents/mainWordContainer.component";
import MainListContainer from "./styledComponents/mainListContainer.component";

const Thank = () => {
  return (
    <React.Fragment>
      <Container
        maxWidth="lg"
        sx={{
          maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          maxHeight: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          paddingLeft: { xs: "0px" },
          paddingRight: { xs: "0px" },
        }}
      >
        <MainImageHeader />
        <Box
          sx={{
            display: { xs: "flex", md: "inline-flex" },
            width: "100%",
            paddingLeft: { md: "100px", xl: "250px" },
            paddingRight: { md: "100px", xl: "250px" },
            justifyContent: { sm: "space-around", md: "space-between" },
            flexDirection: { xs: "column", sm: "row" },
            marginTop: { xs: "10px", sm: "10px", md: "50px" },
          }}
        >
          <MainWordContainer
            title={"Thank you for creating your oDoc Profile!"}
            subTitleOne={
              "An oDoc team member will be in touch with you shortly"
            }
            subTitleTwo={"via email to get you started!"}
          />
          <MainListContainer percent={100} />
        </Box>
      </Container>
    </React.Fragment>
  );
};
export default Thank;
